<p-toast></p-toast>
<h2>Certificates</h2>
<div class="add-btn mb-2">
   <button pButton type="button" label="Add Certificate" icon="pi pi-plus" class="p-button-success"
    (click)="openAddCertificateDialog()" [disabled]="availableCertificates.length === 0">
</button>
</div>


<div class="mat-elevation-z8 mt-4">
    <div class="table-responsive" style="font-size: 14px; margin-bottom: 20px;">
        <p-table #dt2 dataKey="id" [value]="certificates" [rows]="10" [paginator]="true" [showCurrentPageReport]="true"
            [scrollable]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10, 25, 50]" [globalFilterFields]="['name', 'valid_till']">
            <ng-template pTemplate="caption">
                <div class="table-header d-flex justify-content-between align-items-center">
                    <span></span> <!-- Keeps left-aligned content (if needed) -->
                    <input type="text" pInputText size="50" placeholder="Search"
                        (input)="dt2.filterGlobal($event.target.value, 'contains')" style="width: 250px;" />
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="name">
                        <b>Certificate Name</b><p-sortIcon field="name"></p-sortIcon>
                    </th>
                    <th pSortableColumn="valid_till">
                        <b>Valid Till</b><p-sortIcon field="valid_till"></p-sortIcon>
                    </th>
                    <th>
                        <b>Verified By</b><p-sortIcon field="valid_till"></p-sortIcon>
                    </th>
                    <th>
                        <b>File</b><p-sortIcon field="approve"></p-sortIcon>
                    </th>
                    <th>
                        <b>Delete Certificate</b><p-sortIcon field="delete_cert"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-certificate>
                <tr>
                    <td>{{ certificate.document_name }}</td>
                    <td>{{ certificate.expires_on ? (certificate.expires_on | date) : 'N/A' }}</td>
                    <td>{{ certificate.verified_by }}</td>
                    <td> <p-button label="Download Certificate"
                            (click)="DownloadCertificate(certificate.id,certificate.doctor_user_guid)"></p-button></td>
                    <td>
                        <button pButton type="button" class="ui-button-danger" icon="pi pi-trash"
                            (click)="openDeleteDialog(certificate.id)" style="margin-left: .5em"
                            label="Delete"></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<p-dialog [(visible)]="showAddCertificateDialog" (onHide)="closeAddCertificateDialog()" header="Add Certificate"
    [modal]="true" [closable]="true" [responsive]="true" [style]="{width: '500px'}">
    <div class="p-fluid">
        <label for="name" class="dialog-label" required>Certificate Name<span style="color:red">*</span></label>
        <div class="field d-flex justify-content-center align-items-center" style="margin-bottom: 1rem;">
            <p-dropdown id="name" [options]="availableCertificates" [(ngModel)]="certificate.name"
                placeholder="Select a Certificate" optionLabel="name" [style]="{ width: '100%' }"></p-dropdown>
        </div>
        <label for="expiryDate" class="dialog-label" required>Expiry Date<span style="color:red">*</span></label>
        <div class="field" style="margin-bottom: 1rem;">
            <p-calendar id="expiryDate" [(ngModel)]="certificate.expiryDate" dateFormat="yy-mm-dd"></p-calendar>
        </div>

        <label for="fileUpload" class="dialog-label" required>Upload Certificate<span style="color:red">*</span></label>
        <!-- <input id="fileUpload" type="file" (change)="onFileSelected($event)"  /> -->
        <div style="margin-bottom: 1rem;">
            <p-fileUpload #fileUpload name="file" id="file" (onRemove)="onRemoveCertificate()"
                styleClass="p-fileUpload-label-fix" (onSelect)="uploadFiles($event.files)" [showUploadButton]="false"
                [showCancelButton]="false" [maxFileSize]="5033165" [multiple]="false" [fileLimit]="1"
                accept=".pdf,image/*">
            </p-fileUpload>
        </div>

        <div class="ui-g-12 text-gray-underline">
            <b>Note :</b>Supported certificate file types are PDF, JPEG, JPG and PNG.
        </div>
        <p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="loading"
            strokeWidth="6"></p-progressSpinner>
    </div>
    <p-footer>
        <div class="d-flex justify-content-end" style="gap: 1rem;">
            <button pButton type="button" label="Cancel" icon="pi pi-times" class="p-button-secondary"
                (click)="closeAddCertificateDialog()"></button>
            <button pButton type="button" label="Add" icon="pi pi-check" class="p-button-success"
                (click)="addCertificate()"></button>
        </div>

        <p *ngIf="this.serverError" style="text-align: center;color:red;margin-top:10px;">{{this.serverError.message}}
        </p>
    </p-footer>
</p-dialog>


<p-dialog [(visible)]="showDeleteDialog" header="Delete Certificate" [modal]="true" [closable]="true"
    [responsive]="true" [style]="{width: '500px'}">
    <div class="p-fluid">
        <p>Are you sure you want to delete this certificate?</p>
    </div>
    <p-footer>
        <div class="d-flex justify-content-end" style="gap: 1rem;">
            <button pButton type="button" label="Cancel" icon="pi pi-times" class="p-button-secondary"
                (click)="closeDeleteDialog()"></button>
            <button pButton type="button" label="Yes" icon="pi pi-check" class="p-button-success"
                (click)="onRemoveCertificate()"></button>
        </div>
    </p-footer>
</p-dialog>